export const HEADERS = [
	{label: 'ID de alerta', key: 'issueId'},
	{label: 'Latitud', key: 'lat'},
	{label: 'Longitud', key: 'lon'},
	{label: 'Nombre', key: 'name'},
	{label: 'Score', key: 'score'},
	{label: 'Threshold', key: 'threshold'},
	{label: 'Fecha y hora', key: 'timestamp'},
	{label: 'MMSI de la nave', key: 'vesselMMSI'},
];